import { css } from "@digits-css"
import { BLUR_MD } from "@digits-shared/themes/blur"
import colors from "@digits-shared/themes/colors"

export const GLASS_GRADIENTS = css`
  background-image:
    radial-gradient(
      52.43% 57.5% at 50% 100%,
      ${colors.translucentWhite40} 0%,
      ${colors.transparent} 100%
    ),
    linear-gradient(139deg, ${colors.transparent} 8.06%, ${colors.translucentWhite10} 70.11%);
`

export const GLASS_LAYER = css`
  background: ${colors.translucentWhite40};
  border: 1px solid ${colors.translucentWhite40};
  background-blend-mode: luminosity;
  backdrop-filter: blur(${BLUR_MD});
`

const GLASS_STROKE_STYLES = css`
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  pointer-events: none;
  background: linear-gradient(
    149deg,
    ${colors.translucentWhite70} 4.33%,
    ${colors.transparent} 34.44%,
    ${colors.transparent} 46.96%,
    ${colors.translucentWhite40} 78.54%
  );
  mask:
    linear-gradient(white 0, white 0) content-box,
    linear-gradient(white 0, white 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
`

/**
 * 1px glass stroke drawn via ::before in a reserved transparent border, so the
 * ring sits beside content (the gradient renders in the border box). Parent must
 * be `position: relative` with a `border-radius` (inherited by ::before).
 */
export const GLASS_STROKE_BORDER = css`
  border: 1px solid transparent;
  box-sizing: content-box;

  &::before {
    padding: 1px;
    ${GLASS_STROKE_STYLES}
  }
`

/**
 * 1.5px glass stroke drawn via ::after so it paints over content that fills the
 * element (e.g. a circular `<img>`), where a ::before ring would be hidden
 * underneath. Parent must be `position: relative` with a `border-radius`.
 */
export const GLASS_STROKE_OVERLAY = css`
  &::after {
    padding: 1.5px;
    ${GLASS_STROKE_STYLES}
  }
`
